<template>
  <category-page
    :category-list="linksAuth"
    route-name="home"
  >
    <template v-slot:top>
      <v-row
        no-gutters
        justify="center"
        align="center"
      >
        <v-col
          cols="0"
          md="3"
        />
        <v-col
          cols="12"
          md="6"
        >
          <v-card>
            <v-card-text class="text-sm-center font-weight-bold">
              <img
                src="/img/worktools.png"
                :width="$vuetify.breakpoint.xs?190/2:190"
                :height="$vuetify.breakpoint.xs?114/2:114"
              ><br><br>
              Bonjour {{ firstName }}, dans quel univers souhaitez-vous aller ?
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="0"
          md="3"
        />
      </v-row>
    </template>
  </category-page>
</template>

<script>
import CategoryPage from './Common/CategoryPage'
import { mapGetters, mapState } from 'vuex'

export default {
  components: { CategoryPage },
  data () {
    return {
      links: [
        {
          title: 'Gestion du temps',
          description: 'Outils permetant de gerrer votre temps de travail',
          icon: 'mdi-timer',
          to: { name: 'temps-home' },
          credentials: ['ROLE_TEMPS_SHOW']
        },
        {
          title: 'Configuration',
          description: 'Outils permetant de gerrer votre temps de travail',
          icon: 'mdi-hammer-wrench',
          to: { name: 'config-home' },
          credentials: ['ROLE_CONFIG_SHOW']
        }
      ]
    }
  },
  computed: {
    ...mapGetters('user', ['hasOneOfPermissions']),
    ...mapState('user', ['firstName']),
    linksAuth () {
      return this.links.filter(link => link.credentials === false ? true : this.hasOneOfPermissions(link.credentials))
    }
  }
}
</script>
<style>
  .underline {
    text-decoration: underline !important;
  }
</style>
